import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

// /krs/firmy and /krs/fundacje are purely static HTML list pages generated by generate-seo.js.
// Mounting React would replace the 500-item list with the React component fallback banner.
// Individual /krs/{slug} pages and /krs hub still get React hydration.
const pathname = window.location.pathname;
const isStaticListPage =
  pathname === '/krs' || pathname === '/krs/' ||
  pathname === '/krs/firmy' || pathname === '/krs/firmy/' ||
  pathname === '/krs/fundacje' || pathname === '/krs/fundacje/';

if (!isStaticListPage) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}